export class LoadedModel {

    model = null
    key = null
    uri = null
    animations = {}

    constructor(key, model, data = {animationMap: {}, animations: {}}) {
        this.key = key
        this.model = model
        this.animations = data.animations
    }

    getKey() {
        return this.key.toLowerCase()
    }

    getModel() {
        return this.model
    }

    getAnimations() {
        return this.animations
    }

    getUri() {
        return this.uri
    }
}